import * as app from './App'

app.init()

export const load = app.load
export const onLoad = app.onLoad
